import { render } from "./Logout.vue?vue&type=template&id=45be629a&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=45be629a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-45be629a"

export default script